import * as React from 'react';
import {Group} from 'react-konva';
import {FinishLine} from './finish_line';
import {AnimatingBoats} from './animating_boats';
import {Lane} from '../internal/lanes_provider';
import {BoatProgress} from '../../../business/boats/boats_progress_provider';
import {yPositionIsInViewport} from '../calculators/position_in_viewport_calculator';
import {StartLine} from './start_line';
import {Countdown} from './countdown';
import {BoatsScreenComponent} from '../boats_screen_component';
import {SplitLines} from './split_lines';

interface OwnProps {
    viewportOffsetPx: number;
    meterInPx: number;
    distanceMeters: number;
    canvasWidth: number;
    canvasHeight: number;
    lanes: readonly Lane[];
    boats: readonly BoatProgress[];
    finishLineBlockSizePx: number;
    imageSizeMultiplier: number;
    marginTopPx: number;
    boatsScreenComponent: BoatsScreenComponent;
}

export const WaterContent: React.FunctionComponent<OwnProps> = ({
    viewportOffsetPx,
    meterInPx,
    distanceMeters,
    canvasHeight,
    canvasWidth,
    lanes,
    boats,
    finishLineBlockSizePx,
    imageSizeMultiplier,
    marginTopPx,
    boatsScreenComponent,
}) => {
    const finishLineY = canvasHeight - distanceMeters * meterInPx;
    const displayFinishLine = yPositionIsInViewport(finishLineY, canvasHeight, viewportOffsetPx, marginTopPx);
    const startLineY = canvasHeight;
    const displayStartLine = yPositionIsInViewport(startLineY, canvasHeight, viewportOffsetPx, marginTopPx + 200);

    return (
        <Group y={viewportOffsetPx}>
            <SplitLines
                height={finishLineBlockSizePx}
                viewportOffsetPx={viewportOffsetPx}
                meterInPx={meterInPx}
                canvasWidth={canvasWidth}
                canvasHeight={canvasHeight}
                marginTopPx={marginTopPx}
                distanceMeters={distanceMeters}
            />
            {displayStartLine && (
                <Countdown canvasWidth={canvasWidth} y={startLineY} boatsScreenComponent={boatsScreenComponent} />
            )}
            {displayStartLine && <StartLine canvasWidth={canvasWidth} height={finishLineBlockSizePx} y={startLineY} />}
            {displayFinishLine && (
                <FinishLine viewportWidth={canvasWidth} blockSizePx={finishLineBlockSizePx} y={finishLineY} />
            )}
            <AnimatingBoats
                boats={boats}
                lanes={lanes}
                distanceMeters={distanceMeters}
                meterInPx={meterInPx}
                marginTopPx={marginTopPx}
                canvasHeight={canvasHeight}
                finishLineHeightPx={finishLineBlockSizePx * 2}
                imageSizeMultiplier={imageSizeMultiplier}
            />
        </Group>
    );
};
